import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../utils/BaseUrl";

const useGetData = (ENDPOINT, queryKey, queryOptions = {}) => {
  const queryResult = useQuery(
    queryKey,
    async () => {
      const response = await axios.get(`${BASEURL}${ENDPOINT}`);
      return response?.data;
    },
    queryOptions
  );

  return queryResult;
};

export default useGetData;
